
import { getUrlApi } from '../utilities/util';
import ApiHandler from './ApiHandlers/ApiHandler'; 

export const baseURL = String(getUrlApi());

export default class CompanyAPI {
    
    static async GetAllCompanies(): Promise<any> {
        return ApiHandler(baseURL).get("/company/getallcompanys");
    }; 

    static async GetCompaniesById(culture : string, id: number): Promise<any> {
        return ApiHandler(baseURL).get(culture + "/company/getcompanybyid/" + id);
        
    }; 

    static async PostCompaniesCreate(CompanyData: { name: string; description: string }): Promise<any> {
        return ApiHandler(baseURL).post("/company/companycreate", CompanyData);
    }

    static async DeleteCompanies(id: string): Promise<any> {
        return ApiHandler(baseURL).post(`/company/companydelete`, id, {
            headers: {
                'Content-Type': 'application/json-patch+json',
            },
        });
    }
    static async UpdateCompanies(CompanyData: { id: string, name: string; description: string;}): Promise<any> {
        return ApiHandler(baseURL).post(`/company/companyupdate`, CompanyData); 
    }
}